function navHeight() {
  const $navbar = document.querySelector('.navbar')

  const resize = _.debounce(function() {
    if ($navbar) {
      const height = $navbar.offsetHeight
      document.documentElement.style.setProperty('--navbarHeight', `${height}px`)
    }
  }, 50)

  bus.on('resize', resize)
  bus.on('resizeContainer', resize)
  resize()
}

export default navHeight
